///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};
modules.ribit.admin = modules.ribit.admin || {};
modules.ribit.admin.access = modules.ribit.admin.access || {};
modules.ribit.admin.access.create = modules.ribit.admin.access.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit.admin.access.create = {
    helper: null,

    /**
     *
     */
    init: function () {
        // Init select2
        $('.modal').on('show.bs.modal', function (e) {
            if ($(this).find('#role_ids').data('select2') === undefined) {
                let opts = {};

                if (bootstrapVersion != 4) {
                    opts.theme = 'bootstrap-' + bootstrapVersion;
                }

                $(this).find('#role_ids').select2(Object.assign({
                    dropdownParent: $(this),
                }, opts));
            }
        });

        $('.modal').on('shown.bs.modal', function (e) {
            $(this).find('#app_models_user_group__group_name').focus();
        });

        // The search field had a key pressed
        $('#user-search').val('').on('keyup', function(e) {
            var value = $(this).val().toLowerCase();

            // Reset all filters
            $('.access_model li').show();
            $('li.parent').unhighlight();

            if (value) {
                // Filter down the parents + dashboards to what was typed
                $('.access_model li.parent').filter(function() {
                    $(this).highlight(value);
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    $(this).toggleClass('filtered', $(this).text().toLowerCase().indexOf(value) == -1);
                });

                // Hide dashboards based on parents that are hidden
                $('.access_model li.parent.filtered').each(function() {
                    $(this).closest('ul').find('li[data-parent=' + $(this).data('id') + ']').hide();
                });
            }
        });

        // Treeview parent clicked
        $(document).on('click', 'li.parent', function() {
            $(this).toggleClass('active');
            $(this).closest('ul').find('li[data-parent=' + $(this).data('id') + '], li[data-instance-id=' + $(this).data('id') + ']').slideToggle(250);
        });

        // Delete user group button clicked
        $(document).on('click', '.delete-user-group', function() {
            const button = $(this);

            if (confirm('Are you sure you want to delete this user group?')) {
                axios.delete('/users/groups/' + button.data('id')).then(response => {
                    button.closest('ul').find('li[data-parent=' + button.data('id') + '], li[data-instance-id=' + button.data('id') + '], i[data-id=' + button.data('id') + ']').fadeOut('slow', function() {
                        $(this).remove();
                    });

                    button.closest('li').fadeOut('slow', function() {
                        $(this).remove();
                    });
                });
            }
        });

        // Expand / Collapse All User Groups Button Clicked
        $(document).on('click', '.expand-collapse-all', function() {
            const button = $(this);

            // If one of the items is already expanded, collapse all....else expand all
            if (button.closest('ul').find('li.parent').hasClass('active')) {
                button.closest('ul').find('li.parent').removeClass('active');
                button.closest('ul').find('li.parent').closest('ul').find('li[data-parent]').hide();
            } else {
                button.closest('ul').find('li.parent').addClass('active');
                button.closest('ul').find('li.parent').closest('ul').find('li[data-parent]').show();
            }
        });

        // Init jquery-ui sortable
        $(".sortable").sortable({
            connectWith: ".sortable",
            opacity: '.5',
            placeholder: "sortable-placeholder",
            forcePlaceholderSize: true,
            cancel: ".parent, .no-move, .title",

            helper: function(e, li) {
                modules.ribit.admin.access.create.helper = li.clone().addClass('cloning').hide().insertAfter(li);
                return li.clone();
            },

            remove: function(e, ui) {
                modules.ribit.admin.access.create.helper.show().removeClass('cloning');
                $('.sortable li.cloning').remove();
            },

            receive: function(e, ui) {
                // Dont allow when dropped in the 0 position
                if ($(this).find('li').index(ui.item) == 0) {
                    ui.item.remove();
                }

                // Work the li items backwards until we find the parent
                var parent = modules.ribit.admin.access.create.findParentItem(ui.item);

                // Update the parent key on the dashboard item
                ui.item.attr('data-parent', parent.data('id'));

                // Check if dashboard already exists for parent
                if ($(this).find('li[data-parent=' + parent.data('id') + ']').filter('li[data-id=' + ui.item.data('id') + ']').length > 1) {
                    ui.item.remove();
                    alert(ui.item.text() + ' has already been added to ' + parent.text().trim());

                } else {
                    ui.item.loadLivewireComponent('ribit::dashboard-filter', {
                        'entity': parent.data('entity'),
                        'entity_id': parent.data('id'),
                        'domo_dashboard_id': ui.item.data('id'),
                    }, function() {
                        // The livewire component finished - auto pop the filter modal
                        modules.ribit.admin.access.create.domoDashboardInitSelect2();
                        var elem = $('li[data-id="' + ui.item.data('id') + '"][data-parent="' + parent.data('id') + '"]');

                        // For some reason, just clicking isn't working
                        // elem.find('.btn-edit-filter').trigger('click');
                        window.livewire.find(elem.closest('li.dashboard').attr('wire:id')).call('showFilter');
                        $(elem.find('.btn-edit-filter').data('bs-target')).modal('show');
                    });
                }
            },
        });

        // Remove dashboard access button clicked
        $(document).on('click', '.dashboard .btn-remove', function () {
            var item = $(this).closest('li.dashboard');

            if (confirm('Are you sure you want to remove this dashboard access?')) {
                item.fadeOut(function() {
                    item.remove();
                    window.livewire.find($(this).closest('li.dashboard').attr('wire:id')).call('deleteFilter');
                });
            }
        });

        window.addEventListener('dashboard-filter-updated', event => {
            modules.ribit.admin.access.create.domoDashboardInitSelect2();
        });

        modules.ribit.admin.access.create.domoDashboardInitSelect2();
    },

    /**
     * Work the li items backwards until we find the parent
     *
     * @param {*} item
     */
    findParentItem: function(item) {
        for (let i = item.closest('ul').find('li:not(.filtered)').index(item); i >= 0; i --) {
            if (item.closest('ul').find('li:not(.filtered)').eq(i).hasClass('parent')) {
                return item.closest('ul').find('li:not(.filtered)').eq(i);
            }
        }
    },

    domoDashboardInitSelect2: function() {
        // Hide open select2 dropdowns
        $('.select2-container.select2-container--open').remove();

        let opts = {};

        if (bootstrapVersion != 4) {
            opts.theme = 'bootstrap-' + bootstrapVersion;
        }

        $('.dashboard_filter_modal select.filters').not('[data-select2-id]').each(function() {
            let modal = $(this).closest('.dashboard_filter_modal').attr('id');

            $(this).select2(Object.assign({
                dropdownParent: $('#' + modal),
                // allowClear: true,
                minimumInputLength: 0,
                ajax: {
                    cache: true,
                    url: '/api/data_set/searchByDashboard',
                    dataType: 'json',
                    data: function (params) {
                        var query = {
                            q: params.term,
                            domo_dashboard_id: $(this).data('domo_dashboard_id'),
                            column: $(this).closest('.filter-group').find('.column').val(),
                        }

                        return query;
                    },
                },
            }, opts)).on('change.select2', function (e) {
                // Manually set the model file because select2 doesn't work with livewire
                window.livewire.find($(this).closest('li.dashboard').attr('wire:id'))
                    .call('updateFilters', [$(this).attr('wire:model'), $(this).select2("val")]);

                // NOTE: For some reason, the set function isn't working correctly here
                // @this.set($(this).attr('wire:model'), $(this).select2("val"));
            });
        });
    }
};
